module.exports = __webpack_public_path__ + "img/Suto_580x440.51284741.png";